// extracted by mini-css-extract-plugin
export default {"section":"AddressList_section__dEnZ1","list":"AddressList_list__OoaOi","item":"AddressList_item__3YuDi"};